import { render } from "./UploadPanel.vue?vue&type=template&id=7b25f87f&scoped=true"
import script from "./UploadPanel.vue?vue&type=script&lang=js"
export * from "./UploadPanel.vue?vue&type=script&lang=js"

import "./UploadPanel.vue?vue&type=style&index=0&id=7b25f87f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b25f87f"]])

export default __exports__